import React__default from 'react';
import { Operations, Hooks } from '@grandvisionhq/carts-v2';
import { useMutation } from '@grandvisionhq/graphql';
import { getPaymentImplementation } from '@grandvisionhq/payments';
import { isNil } from '@grandvisionhq/utils';
import { getRestPaymentMethodName } from '../../StepPayment/utils/get-payment-method-name.js';

const findAdditionalCostForPayment = (additionalCosts, paymentMethod)=>{
    return additionalCosts.find((p)=>p.key === paymentMethod
    );
};
const useAddAdditionalCosts = ()=>{
    var ref, ref1, ref2;
    const [removeCartItems, removeCartLineItemsMutation] = useMutation(Operations.Mutations.REMOVE_CART_LINE_ITEMS);
    const { data: data1  } = Hooks.useGetCart();
    const [addToCart, addToCartMutation] = Hooks.useAddToCart();
    const currentAdditionalCostsForPaymentLineItem = data1 === null || data1 === void 0 ? void 0 : (ref = data1.getCart) === null || ref === void 0 ? void 0 : (ref1 = ref.cart) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.additionalCartCostLineItems) === null || ref2 === void 0 ? void 0 : ref2[0];
    const removeFromCart = React__default.useCallback((lineItemId)=>{
        const cartId = data1 === null || data1 === void 0 ? void 0 : data1.getCart.cart.id;
        if (isNil(cartId)) {
            console.error('No cart ID available');
            return;
        }
        removeCartItems({
            variables: {
                cartInput: {
                    cartId,
                    lineItems: [
                        {
                            id: lineItemId
                        }, 
                    ]
                }
            },
            update (cache, { data  }) {
                if (data && data.removeCartLineItems.success) {
                    const newCart = data.removeCartLineItems.cart;
                    cache.writeQuery({
                        query: Operations.Queries.GET_CART,
                        variables: {
                            id: cartId
                        },
                        data: newCart
                    });
                }
            }
        });
    }, [
        data1 === null || data1 === void 0 ? void 0 : data1.getCart.cart.id,
        removeCartItems
    ]);
    const addAdditionalPaymentCostsIfApplicable = React__default.useCallback((selectedPaymentMethod, additionalCosts, selectedAdditionalCartCosts)=>{
        const selectedPaymentImplementation = selectedPaymentMethod && getPaymentImplementation(selectedPaymentMethod === null || selectedPaymentMethod === void 0 ? void 0 : selectedPaymentMethod.provider, selectedPaymentMethod === null || selectedPaymentMethod === void 0 ? void 0 : selectedPaymentMethod.type);
        let finalAdditionalCartCosts;
        if (!selectedAdditionalCartCosts) {
            finalAdditionalCartCosts = additionalCosts && selectedPaymentImplementation && findAdditionalCostForPayment(additionalCosts, getRestPaymentMethodName(selectedPaymentImplementation.type));
        } else {
            finalAdditionalCartCosts = selectedAdditionalCartCosts;
        }
        const isReelectingAdditionalCosts = finalAdditionalCartCosts && currentAdditionalCostsForPaymentLineItem;
        let applicable = true;
        if (!selectedPaymentMethod || !selectedPaymentImplementation || isReelectingAdditionalCosts || !additionalCosts || !(additionalCosts === null || additionalCosts === void 0 ? void 0 : additionalCosts.length)) {
            applicable = false;
        }
        if (!applicable) {
            return;
        }
        if (finalAdditionalCartCosts && !currentAdditionalCostsForPaymentLineItem) {
            addToCart([
                {
                    sku: finalAdditionalCartCosts.masterVariant.sku || '',
                    quantity: 1,
                    type: 'regular'
                }, 
            ]);
        }
        if (currentAdditionalCostsForPaymentLineItem) {
            removeFromCart(currentAdditionalCostsForPaymentLineItem.id);
        }
    }, [
        currentAdditionalCostsForPaymentLineItem,
        addToCart,
        removeFromCart
    ]);
    return {
        addAdditionalPaymentCostsIfApplicable,
        error: {
            addAdditionalCartCostError: addToCartMutation === null || addToCartMutation === void 0 ? void 0 : addToCartMutation.error,
            removeAdditionalCartCostError: removeCartLineItemsMutation === null || removeCartLineItemsMutation === void 0 ? void 0 : removeCartLineItemsMutation.error
        }
    };
};

export { findAdditionalCostForPayment, useAddAdditionalCosts };
//# sourceMappingURL=use-add-additional-costs.js.map
